import React from "react";
import classNames from "classnames";
const TextBlock = ({ limitToReadableWidth, children }) => {
    return (React.createElement("div", { className: classNames("gui-textBlock", "m-textWithFormatting", {
            "m-limitToReadableWidth": limitToReadableWidth
        }) }, children));
};
TextBlock.defaultProps = {
    limitToReadableWidth: true
};
export default TextBlock;
//# sourceMappingURL=TextBlock.js.map